import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { AppState } from './store/app.reducer';
import { DEFAULT_LANG } from './conf/languages';
import * as AuthActions from 'src/app/store/auth/auth.actions';
import { User } from './model/user';
import { Observable, Subscription } from 'rxjs';
import { selectUser } from './store/user/user.selector';
import { THEME_CAME_CLASSIC_CSS, THEME_CAME_NEW_CSS, THEME_CAME_NEW_NAME } from './conf/user';
import { environment } from 'src/environments/environment';
import { initializeApp } from "firebase/app";
import { Analytics, getAnalytics } from "firebase/analytics";
import { HttpClient } from '@angular/common/http';
import { MaintenancePollingService } from './services/maintenance-polling.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
	user$: Observable<User | undefined>;
	userSub: Subscription | undefined;

	theme = 'came'; // dim: high contrast old black, came: new came cyan

	// Primeng layout
	topbarTheme = this.theme;
	menuTheme = this.theme;
	layoutMode = this.theme;
	menuMode = 'static';
	isRTL = false;
	inputStyle = 'outlined';
	ripple = true;

	// Device configurator
	isOnline = true;

	constructor(
		private primengConfig: PrimeNGConfig,
		private translate: TranslateService,
		private store: Store<AppState>,
		private http: HttpClient,
		private maintenancePollingService: MaintenancePollingService,
	) {
		this.initSelectors();
	}

	ngOnInit() {
		this.primengConfig.ripple = true;

		this.translate.setDefaultLang(DEFAULT_LANG.code);
		this.translate.get('primeng').subscribe(res => this.primengConfig.setTranslation(res)); // set prime ng components locale (eg: calendar component)
		this.store.dispatch(AuthActions.autoLogin({ dest: window.location.pathname }));
		this.subscribeAll();
		this.loadScript('https://maps.googleapis.com/maps/api/js?key=' + environment.googleAPI + '&v=weekly&libraries=marker').then(() => {
			console.log('Success')
		})
		this.initFirebase();
		this.maintenancePollingService.start();
	}


	loadScript(name: string) {
		return new Promise<void>((resolve, reject) => {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = name;
			document.getElementsByTagName('head')[0].appendChild(script);
			console.log('Script Loaded');
			resolve();
		});
	}

	ngOnDestroy(): void {
		this.userSub?.unsubscribe();
		this.maintenancePollingService.stop();
	}

	initSelectors(): void {
		// Store selectors
		this.user$ = this.store.select(selectUser);
	}

	subscribeAll(): void {
		this.userSub = this.user$?.subscribe(currentUser => {
			if (currentUser && currentUser.ThemeFe) {
				switch (currentUser.ThemeFe) {
					case THEME_CAME_NEW_NAME: {
						this.theme = THEME_CAME_NEW_CSS;
						this.topbarTheme = THEME_CAME_NEW_CSS;
						this.menuTheme = THEME_CAME_NEW_CSS;
						this.layoutMode = THEME_CAME_NEW_CSS;
						break;
					}
					default: {
						this.theme = THEME_CAME_CLASSIC_CSS;
						this.topbarTheme = THEME_CAME_CLASSIC_CSS;
						this.menuTheme = THEME_CAME_CLASSIC_CSS;
						this.layoutMode = THEME_CAME_CLASSIC_CSS;
						break;
					}
				}
			}
		});
	}

	initFirebase(): Analytics {
		const firebaseConfig = {
			apiKey: environment.firebase_apiKey,
			authDomain: environment.firebase_authDomain,
			projectId: environment.firebase_projectId,
			storageBucket: environment.firebase_storageBucket,
			messagingSenderId: environment.firebase_messagingSenderId,
			appId: environment.firebase_appId,
			measurementId: environment.firebase_measurementId
		};

		// Initialize Firebase
		const app = initializeApp(firebaseConfig);
		const analytics = getAnalytics(app);

		return analytics;
	}

}
